
import { useState, useEffect } from "react";
import { RecipeIdea, RecipeDifficulty, RecipeCategory } from "../types";

const useRecipeFormState = (recipe: RecipeIdea | null) => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [ingredients, setIngredients] = useState<string[]>([""]);
  const [instructions, setInstructions] = useState("");
  const [prepTime, setPrepTime] = useState("");
  const [cookTime, setCookTime] = useState("");
  const [totalTime, setTotalTime] = useState("");
  const [servings, setServings] = useState<number>(4);
  const [difficulty, setDifficulty] = useState<RecipeDifficulty>("Medium");
  const [category, setCategory] = useState<RecipeCategory>("Holiday Treats");
  const [tags, setTags] = useState<string[]>([""]);
  const [imageUrl, setImageUrl] = useState("");
  const [kidFriendly, setKidFriendly] = useState(false);
  
  // Initialize form with recipe data if editing
  useEffect(() => {
    if (recipe) {
      setTitle(recipe.title);
      setDescription(recipe.description);
      setIngredients(recipe.ingredients.length > 0 ? recipe.ingredients : [""]);
      setInstructions(recipe.instructions);
      setPrepTime(recipe.prepTime);
      setCookTime(recipe.cookTime);
      setTotalTime(recipe.totalTime);
      setServings(recipe.servings);
      setDifficulty(recipe.difficulty);
      setCategory(recipe.category);
      setTags(recipe.tags.length > 0 ? recipe.tags : [""]);
      setImageUrl(recipe.imageUrl || "");
      setKidFriendly(recipe.kidFriendly);
    }
  }, [recipe]);
  
  // Ingredient management functions
  const addIngredient = () => {
    setIngredients([...ingredients, ""]);
  };
  
  const updateIngredient = (index: number, value: string) => {
    const updated = [...ingredients];
    updated[index] = value;
    setIngredients(updated);
  };
  
  const removeIngredient = (index: number) => {
    if (ingredients.length > 1) {
      const updated = [...ingredients];
      updated.splice(index, 1);
      setIngredients(updated);
    }
  };
  
  // Tag management functions
  const addTag = () => {
    setTags([...tags, ""]);
  };
  
  const updateTag = (index: number, value: string) => {
    const updated = [...tags];
    updated[index] = value;
    setTags(updated);
  };
  
  const removeTag = (index: number) => {
    if (tags.length > 1) {
      const updated = [...tags];
      updated.splice(index, 1);
      setTags(updated);
    }
  };
  
  // Wrapper functions for setCategory and setDifficulty to handle type conversions
  const handleCategoryChange = (value: RecipeCategory) => {
    setCategory(value);
  };
  
  const handleDifficultyChange = (value: RecipeDifficulty) => {
    setDifficulty(value);
  };

  return {
    title,
    setTitle,
    description,
    setDescription,
    ingredients,
    setIngredients,
    updateIngredient,
    removeIngredient,
    addIngredient,
    instructions,
    setInstructions,
    prepTime,
    setPrepTime,
    cookTime,
    setCookTime,
    totalTime,
    setTotalTime,
    servings,
    setServings,
    difficulty,
    setDifficulty,
    handleDifficultyChange,
    category,
    setCategory,
    handleCategoryChange,
    tags,
    setTags,
    updateTag,
    removeTag,
    addTag,
    imageUrl,
    setImageUrl,
    kidFriendly,
    setKidFriendly
  };
};

export default useRecipeFormState;
